import { Attrs, MinzeElement } from 'minze'

export interface LvcShareFacebookIcon {}

export class LvcShareFacebookIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', 32],
    ['height', 32],
  ]

  html = () => `
    <svg part="icon" width="${this.width}" height="${this.height}" viewBox="0 0 15 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.9199 0.0213451L10.0644 0.0001297C4.67516 0.0001297 3.45094 4.09363 3.45094 6.70701V10.3619H0.333496V16.0105H3.45094V32.0001H10.0065V16.0105H14.428L15.0002 10.3673H10.0065V7.04348C10.0065 5.79673 10.8191 5.50367 11.3971 5.50367H14.9199V0.0213451Z" fill="#1C0080"/>
    </svg>
  `

  css = () => `
    
  `
}
